import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import coursesSlice from "./slices/courses";
import assessmentsSlice from "./slices/assessments";
import popInSessionsSlice from "./slices/popInSessions";
import usersSlice from "./slices/users";
import proctoringSessionsSlice from "./slices/proctoringSessions";

export default function createStore() {
	const store = configureStore({
		reducer: {
			[coursesSlice.reducerPath]: coursesSlice.reducer,
			[assessmentsSlice.reducerPath]: assessmentsSlice.reducer,
			popInSessions: popInSessionsSlice.reducer,
			[usersSlice.reducerPath]: usersSlice.reducer,
			[proctoringSessionsSlice.reducerPath]: proctoringSessionsSlice.reducer,
		},
		middleware: (getDefaultMiddleware) =>
			getDefaultMiddleware()
				.concat(coursesSlice.middleware)
				.concat(assessmentsSlice.middleware)
				.concat(usersSlice.middleware)
				.concat(proctoringSessionsSlice.middleware),
	});
	setupListeners(store.dispatch);
	return store;
}

export type Store = ReturnType<typeof createStore>;
export type RootState = ReturnType<Store["getState"]>;
